import React from 'react';
import Box from '@mui/material/Box';

const GridItem = ({ children, ...props }) => {
  return (
    <Box sx={{...props,maxWidth:350,marginTop:{xs:1},marginBottom:{xs:1}}}>
      {children}
    </Box>
  );
};

export default GridItem;